import { Component, OnInit, signal, computed } from '@angular/core';
import { BaseComponent } from '../../../../core/abstracts/baseComponent';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { State } from '../../../../core/store';
import { SelectItem } from 'primeng/api';
import { getManagePtoEarnedList, loadViewableCampuses, savePtoEarnedSuccess, showEditPtoEarned } from '../../../../core/store/timeoff/timeoff.actions';
import { formatDate } from '@angular/common';
import { deepClone, getDateWithOffset } from '../../../../helpers/utils';
import { PtoEarnedModel } from '../../../../models/timeoffModel';
import { PagingResultsModel } from '../../../../models/pagingResultsModel';
import { tap } from 'rxjs';
import { loadEmployeeUsers } from '../../../../core/store/employee/employee.action';
import { UserAutoCompleteItem } from '../../../../models/utilModels';

@Component({
    selector: 'app-list-pto-manage',
    templateUrl: './list-pto-manage.component.html',
    styleUrls: ['./list-pto-manage.component.scss'],
    standalone: false
})
export class ListPtoManageComponent extends BaseComponent implements OnInit {
  filter: any;
  ptoEarnedList: PagingResultsModel<PtoEarnedModel>;

  loadingList: boolean = true;
  canEdit: boolean = false;
  canViewSchedulingTimeOff: boolean = false;

  campusList: SelectItem[];
  campusId: number = 0;

  selectedUserEmployee: UserAutoCompleteItem;
  userList: UserAutoCompleteItem[];
  userId: number = 0;

  startDate: string = formatDate(getDateWithOffset(-13), 'yyyy-MM-dd', 'en-US');
  endDate: string = formatDate(new Date(), 'yyyy-MM-dd', 'en-US');
  
  totalRecords = signal<number>(0);
  dropdownOptions = computed(() => {
    var total = this.totalRecords();
    return [
      { label: '20', value: 20 },
      { label: '50', value: 50 },
      { label: '100', value: 100 },
      { label: '200', value: 200 },
      { label: '500', value: 500 },
      { label: 'All', value: total > 0 ? total : 20 } 
    ];
  });

  constructor(
    private actions$: Actions,
    private store: Store<State>) {
    super();
  }

  ngOnInit() {
    this.subs.push(
      this.store.select(s => s.timeoffState.loadingManagePtoEarnedList).subscribe(loadingList => {
        this.loadingList = loadingList;
      }),
      this.store.select(s => s.accountState.user?.permissionIDs).subscribe(permissionIDs => {
        this.canEdit = permissionIDs && !!permissionIDs.find(p => p === 3103);
        this.canViewSchedulingTimeOff = permissionIDs && !!permissionIDs.find(p => p === 186);
      }),
      this.store.select(s => s.timeoffState.campuses).subscribe(campuses => {
        this.campusList = campuses && campuses.length > 0 ? campuses
          : [{ label: 'loading...', value: undefined }];
      }),
      this.store.select(s => s.employeeState.employeeUsers).subscribe(users => {
        this.userList = users.map(x => ({
          id: x.value,
          name: x.label
        }));
      }),
      this.store.select(s => s.timeoffState.managePtoEarnedList).subscribe(ptoList => {
        this.ptoEarnedList = ptoList; 
        if(ptoList != null)
     	  	  	  this.totalRecords.set(ptoList.totalRecords);
      }),
      this.actions$.pipe(
        ofType(savePtoEarnedSuccess),
        tap(action => {
          this.reloadList();
        })
      ).subscribe(),
    );

    this.store.dispatch(loadViewableCampuses());
  }

  reloadFilter(event) {
    this.filter = event;
    this.reloadList();
  }

  getStaffList(event) {
    this.store.dispatch(loadEmployeeUsers({
      prefixText: event.query,
      programId: this.campusId,
      payrollClassificationId: 0,
      showInactive: true,
      showTerminated: true
    }));
  }

  reloadListAfterStaffChage(selectedUser) {
    if (typeof selectedUser.value.id !== 'number') {
      return;
    }

    this.userId = selectedUser.value.id;
    this.reloadList();
  }

  reloadListAfterClear(event) {
    
    this.userId = 0;
    this.reloadList();
  }  

  reloadList() {
    this.filter = deepClone(this.filter);

    this.filter.filters.userId = { Name: 'userId', Value: { value: this.userId.toString() } };
    this.filter.filters.programId = { Name: 'programId', Value: { value: this.campusId.toString() } };
    this.filter.filters.startDate = { Name: 'startDate', Value: { value: this.startDate } };
    this.filter.filters.endDate = { Name: 'endDate', Value: { value: this.endDate } };

    this.store.dispatch(getManagePtoEarnedList({
      filter: this.filter
    }));
  }

  editPtoEarned(request) {
    this.store.dispatch(showEditPtoEarned({ ptoEarned: request }));
  }

}
